/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch, useReducer } from 'react';
import { SseResultObject } from '../states';
import {
  initialStateOperationStarted,
  initialStateSelfieCaptured,
  initialStateFacialAuthentication,
  initialStatePassiveLiveness,
  initialStateOperationFinished,
  initialStateOperationExpired,
} from './InitialReducersStates';
import {
  operationStartedReducer,
  selfieCapturedReducer,
  facialAuthenticationReducer,
  passiveLivenessReducer,
  operationFinishedReducer,
  operationExpiredReducer,
} from './Reducers';
import { ActionTypeRequest, StateRequest } from './RequestReducer';

export enum DispatchersTitles {
  SELFIE_CAPTURED = 'SelfieCaptured',
  FACIAL_AUTHENTICATION_EVALUATED = 'FacialAuthenticationEvaluated',
  PASSIVE_LIVENESS_EVALUATED = 'PassiveLivenessEvaluated',
  OPERATION_FINISHED = 'OperationFinished',
  OPERATION_STARTED = 'OperationStarted',
  OPERATION_EXPIRED = 'OperationExpired',
}

export type Dispatchers = {
  [K in DispatchersTitles as `dispatch${K}`]: Dispatch<ActionTypeRequest<any>>;
};

export type CardStates = {
  operationStarted: StateRequest<SseResultObject['OPERATION_STARTED']>;
  selfieCaptured: StateRequest<SseResultObject['SELFIE_CAPTURED']>;
  facialAuthenticationEvaluated: StateRequest<
    SseResultObject['FACIAL_AUTHENTICATION_EVALUATED']
  >;
  passiveLivenessEvaluated: StateRequest<
    SseResultObject['PASSIVE_LIVENESS_EVALUATED']
  >;
  operationFinished: StateRequest<SseResultObject['OPERATION_FINISHED']>;
  operationExpired: StateRequest<SseResultObject['OPERATION_EXPIRED']>;
};

export const useDispatchers = () => {
  const [operationStarted, dispatchOperationStarted] = useReducer(
    operationStartedReducer,
    initialStateOperationStarted
  );

  const [selfieCaptured, dispatchSelfieCaptured] = useReducer(
    selfieCapturedReducer,
    initialStateSelfieCaptured
  );

  const [facialAuthenticationEvaluated, dispatchFacialAuthenticationEvaluated] =
    useReducer(facialAuthenticationReducer, initialStateFacialAuthentication);

  const [passiveLivenessEvaluated, dispatchPassiveLivenessEvaluated] =
    useReducer(passiveLivenessReducer, initialStatePassiveLiveness);

  const [operationFinished, dispatchOperationFinished] = useReducer(
    operationFinishedReducer,
    initialStateOperationFinished
  );

  const [operationExpired, dispatchOperationExpired] = useReducer(
    operationExpiredReducer,
    initialStateOperationExpired
  );

  const dispatchers: Dispatchers = {
    dispatchOperationStarted,
    dispatchSelfieCaptured,
    dispatchFacialAuthenticationEvaluated,
    dispatchPassiveLivenessEvaluated,
    dispatchOperationFinished,
    dispatchOperationExpired,
  };

  const cardStates: CardStates = {
    operationStarted,
    selfieCaptured,
    facialAuthenticationEvaluated,
    passiveLivenessEvaluated,
    operationFinished,
    operationExpired,
  };

  return {
    dispatchers,
    cardStates,
  };
};
